import { controls } from "../../controls";

const rp1213 = {
  label: "Grade Wise Pay Ledger",
  pageLabel: "Grade Wise Pay Ledger",
  starting: true,
  url: "rp1213",

  pageType: "history",
  filter: [

    ...controls.displayText({ tab: "filter", label: "For Year & Month", width: "col-sm-2 " }),
    ...controls.magicDate({ tab: "filter", name: "for_year_&_month", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "for_year_&_month", width: "col-sm-2", placeHolder: "For Year & Month", defaultValue: "",
      options: [{
        label: "January",
        value: "january"
      },
      {
        label: "February",
        value: "february"
      },

      {
        label: "March",
        value: "march"
      },

      {
        label: "April",
        value: "april"
      },

      {
        label: "May",
        value: "may"
      },

      {
        label: "June",
        value: "june"
      },

      {
        label: "Jully",
        value: "jully"
      },

      {
        label: "August",
        value: "august"
      },


      {
        label: "September",
        value: "september"
      },

      {
        label: "October",
        value: "october"
      },

      {
        label: "November",
        value: "november"
      },

      {
        label: "December",
        value: "december"
      }]
    }),



    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", defaultValue: "assigned_branch" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", width: "col-sm-2", displaytype: 'small' }),

    ...controls.displayText({ tab: "filter", label: "Department", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "department", width: "col-sm-2", placeHolder: "Department", defaultValue: "",
      options: [{
        label: "DEVELOPMENT SECTION",
        value: "development_section"
      },
      {
        label: "AUDIT AND INSPECTION SECTIO",
        value: "audit_and_inspection_section"
      },

      {
        label: "COUNTRT SECTION",
        value: "counter_section"
      },

      {
        label: "ADMINISTRATION SECTION",
        value: "administration_section"
      },

      {
        label: "NON AGRI LOAN SECTION 1",
        value: "non_agri_laon_section1"
      },

      {
        label: "FUNDS MANAGEMENT",
        value: "funds_management"
      },

      {
        label: "STOAR SECTION",
        value: "stoar_section"
      },

      {
        label: "VIGILANCE AND SQUAD SECTION",
        value: "vigilance_and_squad_section"
      },


      {
        label: "TRANSFER SECTION",
        value: "transfer_section"
      },

      {
        label: "M.T.LOAN SECTION",
        value: "m_t_loan_section"
      },

      {
        label: "MANAGEMENT STAFF",
        value: "management_staff"
      },

      {
        label: "I.T SECTION",
        value: "i_t_section"
      },

      {
        label: "RECOVER SECTION",
        value: "recover_section"
      },

      {
        label: "NON AGRI LOAN SECTION 2",
        value: "non_agri_laon_section2"
      },

      {
        label: "BANKING SECTION",
        value: "banking_section"
      },

      {
        label: "S.T.LOAN SECTION",
        value: "s_t_loan_section"
      },

      {
        label: "TECHNICAL SECTION",
        value: "technical_section"
      },

      {
        label: "STASTIC SECTION",
        value: "stastic_section"

      }]


    }),

    ...controls.displayText({ tab: "filter", label: "Grade", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "grade", width: "col-sm-2", placeHolder: "Grade", defaultValue: "",
      options: [{
        label: "FIRST GRADE OFFICER(OFF)",
        value: "first_grade_officer(off)"
      },
      {
        label: "JUNIOR OFFICER",
        value: "junio_officer"
      },

      {
        label: "AGRI OFFICER",
        value: "agri_officer"
      },

      {
        label: "PROBATIONARY PEON",
        value: "probationarr_peon"
      },

      {
        label: "CHEIF OFFICER(OFF)",
        value: "cheif_officer(off)"
      },

      {
        label: "JUNIOR OFFICER(OFF)",
        value: "junio_officer(off)"
      },

      {
        label: "DRIVER",
        value: "driver"
      },

      {
        label: "BRANCH MANAGER",
        value: "branch_manager"
      },


      {
        label: "ASST. MANAGER",
        value: "asst_manager"
      },

      {
        label: "CLERK",
        value: "clerk"
      },

      {
        label: "BANK INSPECTOR",
        value: "bank_inspector"
      },

      {
        label: "BANK INS/GOD KEEPAR",
        value: "bank_ins_god_keepar"
      },

      {
        label: "PROBATIONARY DRIVER",
        value: "probationarr_driver"
      },

      {
        label: "FIRST GRADE OFFICER",
        value: "first_grade_officer"
      },

      {
        label: "SECTION HEAD",
        value: "secton_head"
      },

      {
        label: "CLERK/COMPUTR TL.CO",
        value: "clerk_computer_tl_co"
      },

      {
        label: "BRANCH MANAGER",
        value: "branch_manager"
      },

      {
        label: "DEPUTY MANAGER",
        value: "deputy_manger"

      },

      {
        label: "MANAGER",
        value: "manger"

      },

      {
        label: "BANK INSPECTOR(OFF)",
        value: "bank_inspector(off)"

      },

      {
        label: "BR.MANAGER/BANK INSPECTOR",
        value: "branch_manager_bank_inspector"

      },

      {
        label: "BR.MAN/BANK INS(OFF)",
        value: "br_manager_bank_ins(off)"

      },

      {
        label: "PEON",
        value: "peon"

      },

      {
        label: "BANK INSPECTOR(CLK GRADE)",
        value: "bank_inspector(clk grade)"

      },

      {
        label: "SENIOR BANK INSPECTOR(FGO)",
        value: "senior_bank_inspector(fgo)"

      },

      {
        label: "PROBATIONARY CLERK",
        value: "probationarr_clerk"

      },

      {
        label: "CLERK/GOD KEEPAR",
        value: "clerk/god_keepar"

      },

      {
        label: "BRANCH MANAGER(OFF)",
        value: "branch_manager(off)"

      },

      {
        label: "ASST MANAGER",
        value: "asst_manager"

      },

      {
        label: "SALES OFFICER",
        value: "sales_officer"

      },

      {
        label: "PROBATIONARY CLERK",
        value: "probationarr_clerk"

      },

      {
        label: "GENERAL MANAGER",
        value: "general_manager"

      },

      {
        label: "PROBATIONARY CLERK",
        value: "probationarr_clerk"

      },

      {
        label: "BR.MANAGER (CLK GRD)",
        value: "br_manager(clk grd)"

      },

      {
        label: "SENIOR BANK INSPECTOR(JO)",
        value: "senior_bank_inspector"

      }]



    }),

    ...controls.displayText({ tab: "filter", label: "DESIGNATION", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "designation", width: "col-sm-2", placeHolder: "DESIGNATION", defaultValue: "",
      options: [{
        label: "AGRI OFFICER (OFFICIATING)",
        value: "agri_officer(officiating)"
      },
      {
        label: "BANK INSPECTOR",
        value: "bank_inspector"
      },

      {
        label: "SALES OFFICER",
        value: "sales_officer"
      },

      {
        label: "GENERAL MANAGER",
        value: "general_manager"
      },

      {
        label: "FIRST GRADE OFFICER",
        value: "first_grade_officer"
      },

      {
        label: "BRANCH MANAGER (CLERK GRADE)",
        value: "branch_manager(clerk grade)"
      },

      {
        label: "DRIVER",
        value: "medical"
      },

      {
        label: "PROBATIONARY DRIVER",
        value: "leave_salary"
      },


      {
        label: "CLEARING",
        value: "clearing"
      },

      {
        label: "JUNIOR OFFICER",
        value: "junio_officer"
      },

      {
        label: "ASSISTANT MANAGER ",
        value: "assistant_manger"
      },

      {
        label: "CLERK GODOWN KEEPAR",
        value: "clerk_godown_keepar"
      },

      {
        label: "SENIOR BANK INSPECTOR(FGO)",
        value: "senior_bank_inspector(fgo)"
      },

      {
        label: "GODOWN KEEPAR(JO)",
        value: "godown_keepar(jo)"
      },

      {
        label: "BANK MANAGER(OFFICIATING)",
        value: "br_manager(officiating)"
      },

      {
        label: "BR.MANAGER/BANKN INSPECTOR",
        value: "br_manager_bank_inspector"
      },

      {
        label: "SECTION HEAD",
        value: "secton_head"
      },

      {
        label: "PROBATIONARY CLERK",
        value: "probationarr_clerk"

      },

      {
        label: "BRANCH MANAGER (GRD 1)",
        value: "branch_manager(grd 1)"

      },

      {
        label: "CLERK",
        value: "clerk"

      },

      {
        label: "GODOWN KEEPAR (FGO)",
        value: "godown_keepar(fgo)"

      },

      {
        label: "BRANCH MANAGER",
        value: "branch_manager"

      },

      {
        label: "HEAD CASHIER",
        value: "head_cash"

      },

      {
        label: "BR.MANAGER/BANK INSPECTOR(CLK GRADE)",
        value: "br_manager_bank_inspector(clk grade)"

      },

      {
        label: "CASH WORK",
        value: "cash_work"

      },

      {
        label: "DEPT.MANAGER (OFFICIATING)",
        value: "dept_manger(officiating)"

      },


      {
        label: "BR.MANAGER/BANK INSPECTOR(OFFI)",
        value: "br_manager_bank_inspector(offi)"

      },

      {
        label: "BANK INSPECTOR / GODOWN KEEPAR",
        value: "bank_inspector_godown_keepar"

      },

      {
        label: "BANK INSPECTOR(OFFICIATING)",
        value: "bank_inspector(officiating)"

      },

      {
        label: "CLERK/COMPUTR TL CO",
        value: "clerk_computer_tl_co"

      },

      {
        label: "CASHIER",
        value: "cashier"

      },

      {
        label: "NIGHT WATCHMAN",
        value: "night_watchman"

      },

      {
        label: "TYPIST",
        value: "typist"

      },

      {
        label: "BANK INSPECTOR(CLERK GRADE)",
        value: "bank_inspector(clerk grade)"

      },

      {
        label: "AGRI OFFICER",
        value: "agri_officer"

      },

      {
        label: "JUNIOR OFFICER(OFFICIATING)",
        value: "junio_officer(officiating)"

      },

      {
        label: "MANAGER",
        value: "manger"

      },

      {
        label: "ASSISTANT MANAGER(OFFICIATING)",
        value: "assistant_manger(officiating)"

      },

      {
        label: "FGO(OFFICIATING)",
        value: "fgo(officiating)"

      },

      {
        label: "PEON",
        value: "peon"

      },

      {
        label: "DEPUTY MANAGER",
        value: "deputy_manger"

      },

      {
        label: "PROBATIONARY PEON",
        value: "probationarr_peon"

      },

      ]
    }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2 " }),





    ...controls.displayText({ tab: "filter", label: "Sort By", width: "col-sm-2" }),
    ...controls.select({
      tab: "filter", name: "sort_by", width: "col-sm-2", placeHolder: "Select", defaultValue: "",
      options: [{
        label: "EmplCode",
        value: "emplcode"
      },

      {
        label: "Grade EmplCode",
        value: "grade_emplcode"
      },

      {
        label: "Designation EmplCode",
        value: "designation_emplcode"
      },


      {
        label: "Department EmplCode",
        value: "department_emplcode"
      },


      {
        label: "Branch EmplCode",
        value: "branch_emplcode"
      },


      {
        label: "Branch Grade EmplCode",
        value: "branch_grade_emplcode"
      },


      {
        label: "Branch Designation EmplCode",
        value: "branch_designation_emplcode"
      },


      {
        label: "Grade Branch EmplCode",
        value: "grade_branch_emplcode"
      },


      {
        label: "Designation Branch EmplCode",
        value: "designation_branch_emplcode"
      },

      {
        label: "Department Branch EmplCode",
        value: "department_branch_emplcode"
      },

      {
        label: "Designation Department EmplCode",
        value: "designation_department_emplcode"
      },

      {
        label: " Designation Grade EmplCode",
        value: "designation_grade_emplcode"
      },


      {
        label: "Department Designation EmplCode",
        value: "department_designation_emplcode"
      },


      {
        label: "Department Grade EmplCode",
        value: "department_grade_emplcode"
      },


      {
        label: "Grade Department EmplCode",
        value: "grade_department_emplcode"
      },


      {
        label: "Grade Designation EmplCode",
        value: "grade_designation_emplcode"
      }]




    }),

    ...controls.checkBox({ tab: "Modal", label: "Group Wise", name: "group wise", width: "col-sm-6", default: true }),

    ...controls.checkBox({ tab: "Modal", label: "Summary", name: "summary", width: "col-sm-6", default: true }),






  ],

  form: [],

  history: {
    perPage: 10,
    reportHeader: "Grade Wise Pay Ledger",
    pdfProps: { pageSize: "A4", pageOrientation: "landscape" },
    displayColumns: [

      {
        Header: "Sr",
        type: "autoinc",
        accessor: "srno",
        width: 30
      },

      {
        Header: "Branch",
        accessor: "branch"

      },

      {
        Header: "Grade",
        accessor: "grade",

      },

      {
        Header: "Designation",
        accessor: "designation",

      },


      {
        Header: "Department",
        accessor: "department",

      },

      {
        Header: "Type",
        accessor: "type",

      },

      {
        Header: "Credit Nos",
        accessor: "credit_nos",

      },


      {
        Header: "Code",
        accessor: "code",

      },


      {
        Header: "Name",
        accessor: "name",

      },

      {
        Header: "Nos",
        accessor: "nos",

      },

      {
        Header: "Month & Year",
        accessor: "month_&_year",

      },


    ]
  }
};

export default rp1213;
